import type { SupportedLangs } from "@/i18n/types";

/** 見出しは日英併記で、どちらの言語でも同じ文字列を表示する。 */
export const LANGUAGE_SELECT_LABEL = "言語 / Language";

/** 言語名は自称表記なので翻訳しない。 */
export const LANGUAGE_SELECT_ENDONYMS: Record<SupportedLangs, string> = {
  ja: "日本語",
  en: "English",
};

export const LANGUAGE_SELECT_RADIO_NAME = "language";
